import { defineComponent, toRef, type PropType } from 'vue';
import { Room } from 'livekit-client';
import { useProvideRoomContext } from '../composables/useRoomContext';

export default defineComponent({
  name: 'LiveKitRoomProvider',
  props: {
    room: {
      type: Object as PropType<Room>,
      required: true,
    },
  },
  setup(props, { slots }) {
    const room = toRef(props, 'room');
    useProvideRoomContext(room);
    return () => slots.default?.();
  },
});
